module.exports = __webpack_public_path__ + "static/media/20ECE30.5369ba7f.jpg";